<template>
  <select
    class="form-control m-input"
    :disabled="disabled"
    @select="emitChangeEvent"
    @change="emitChangeEvent"
  >
    <option v-if="firstOption !== null" value="">{{ firstOption }}</option>
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id == selected"
    >
      {{ status.name }}
    </option>
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectCustomerStatuses',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : null,
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/statuses`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
